import {
	Grid
} from '@material-ui/core'
import {
	Loader,
	RoundArrowButton,
	RoundArrowButtonDirection
} from '@tfo/common'
import { observer } from 'mobx-react'
import * as React from 'react'
import {
	useHistory,
	useParams
} from 'react-router-dom'
import { useStore } from '../../../../../hooks'
import { IGroupSummary } from '../../../../../models/IGroupSummary'
import { ClientViewStore } from '../../../../../stores/ClientViewStore'
import { ReportsStore } from '../../../../../stores/ReportsStore'
import '../../../../../styles/Loader.scss'
import '../../../Client.scss'
import { IddGroupedOrderReportList } from './IddGroupedOrderReportList'
import GroupedOrderReportList from './GroupedOrderReportList'
import GroupOrderSpecification from './OrderSpecification/GroupOrderSpecification'

export const GroupedOrderList = observer(
	({
		groupId,
		companyId,
		hideBackButton,
		backoffice
	}: {
		groupId?: string
		companyId?: string
		hideBackButton?: boolean
		backoffice?: boolean
	}) => {
		const store = useStore().clientViewStore as ClientViewStore
		const { userStore } = useStore()
		const reportsStore = new ReportsStore(
			store.network,
			companyId ? parseInt(companyId) : userStore.user.companyId,
			userStore.userId,
		)
		const [order, setOrder] = React.useState<IGroupSummary>()

		const history = useHistory()
		if (!groupId) {
			const { groupId: id } = useParams<{ groupId: string }>()
			groupId = id
		}

		React.useEffect(() => {
			getOrders()
		}, [])

		const getOrders = async () => {
			const groupOrder = await reportsStore.getGroupedOrders(groupId)
			setOrder(groupOrder)
		}

		const showReport = row => {
			if (backoffice) {
				history.push(`/report-backoffice/${row.orderId}`)
			} else {
				history.push(`/read-report/${row.orderId}`)
			}
		}

		return <>
			{!hideBackButton && (
				<div className={'ClientContainer__ArrowWrapper'}>
					<RoundArrowButton
						direction={RoundArrowButtonDirection.LEFT}
						outlined
						className={'ClientContainer__Back'}
						onClick={() => {
							history.push('/reports')
						}}
					/>
				</div>
			)}
			{store.loading && <Loader />}
			{!store.loading && order && <Grid
				container
				justifyContent='center'
				direction="column"
				className="GridWrapper"
				style={{ marginTop: '8vh' }}>
				{order.orderSpecification && <GroupOrderSpecification specification={order.orderSpecification} summary={order.summary} />}
				{order.isIdd ?
					<IddGroupedOrderReportList reports={order.individualInformation} onSelectedReport={showReport} />
					: <GroupedOrderReportList reports={order.individualInformation} onSelectedReport={showReport} isBackoffice={backoffice} />}
			</Grid>}
		</>
	})
export default GroupedOrderList
